import React, { useState } from 'react';
import { PageHeader } from '../../../survey_engine/SurveyTemplates/PageHeader';
import { Card } from '../../../../components/Card';
import { CardHeader } from '../../../survey_engine/SurveyTemplates/CardHeader';
import { getRedirectUriQueryParam } from '../../../../utils/url';
import { FormHeader } from '../components/FormHeader';
import { ReasonsInput } from '../components/ReasonsInput';
import { JobRequisitionReasonService } from '../../../../services/v1/applicant_tracking/JobRequisitionReasonService';
import { Col } from 'reactstrap';
import { redirectWithAlert } from '../../../../services/FlashService';

const REDIRECT_URI =
  getRedirectUriQueryParam() ??
  '/organization_settings/job_requisition_reasons';
const SUCCESSFUL_ALERT_MESSAGE =
  'The requisition reason was successfully updated!';
interface PropTypes {
  id: number;
  name: string;
}

export default function EditRejectedReasonPage(props: PropTypes) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reasons, setReasons] = useState<string[]>([props.name]);
  const [duplicates, setDuplicates] = useState<string[]>([]);

  function isSavable() {
    return (
      reasons.length > 0 &&
      reasons.every((reason) => reason.length > 0) &&
      duplicates.every((duplicate) => !reasons.includes(duplicate)) &&
      reasons[0].trim() !== props.name
    );
  }

  async function handleSave() {
    setIsLoading(true);

    try {
      await JobRequisitionReasonService.update(props.id, reasons[0].trim());
      redirectWithAlert(REDIRECT_URI, SUCCESSFUL_ALERT_MESSAGE);
    } catch (error) {
      if (error.status !== 409) throw error;

      setDuplicates([reasons[0].trim()]);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className='container'>
        <PageHeader title={props.name} backUrl={REDIRECT_URI} />
        <Card>
          <CardHeader
            title='Edit Requisition Reason'
            isSavable={isSavable()}
            isLoading={isLoading}
            onSaveClick={handleSave}
            cancelUrl={REDIRECT_URI}
          />
          <Col xs={4}>
            <FormHeader mandatory title='Reason Name' />
            <ReasonsInput
              singleInput
              reasons={reasons}
              duplicates={duplicates}
              setReasons={setReasons}
            />
          </Col>
        </Card>
      </div>
    </>
  );
}
